import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {UserHeader} from "./UserHeader";
import {UserTabs} from "./UserTabs";


export class UserContentBase extends Component {
    constructor(props) {
        super(props);
        this.handleAfterSuccessfulUserUpdated = this.handleAfterSuccessfulUserUpdated.bind(this);
        this.state = {
            'name': null,
            'canUseMarketingModule': null,
            'canUseManageAccountsModule': null,
            'userLoggedIsAdmin': null,
            'canUseModuleMarketingAlerts': null
        };
    }


    handleAfterSuccessfulUserUpdated() {
        this.props.afterSuccessfulUserUpdated();
        this.updateClientData();
    }

    UNSAFE_componentWillMount() {
        this.updateClientData();

    }

    setIsSaving(new_value) {
        this.setState({
            ...this.state,
            'isSaving': new_value
        });
    }

    updateClientData() {
        this.setIsSaving(true);
        new APIClient(this.updateUserDataURL()).call('GET').then((data) => {
            this.setIsSaving(false);
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    'name': data.data['name'],
                    'canUseMarketingModule': data.data['can_use_marketing_module'],
                    'canUseManageAccountsModule': data.data['can_use_manage_accounts_module'],
                    'userLoggedIsAdmin': data.data['user_doing_operation_is_admin'],
                    'canUseModuleMarketingAlerts': data.data['can_use_module_marketing_alerts']
                });
            }
        })
    }

    updateUserDataURL() {
        return API_URL + 'user/' + this.props.userId;
    }

    renderHeaderAndTabs(activeTab) {
        return [
            <UserHeader name={this.state.name}/>,
            <UserTabs activeTab={"-"+activeTab} userId={this.props.userId}
                      showModuleMarketing={this.state.canUseMarketingModule}
                      showModuleManageAccounts={this.state.canUseManageAccountsModule}
            />
        ]
    }
}
